import { ChangeDetectorRef, Component, Renderer2 } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { CmsComponentData } from '@spartacus/storefront';
import { BaseSiteService, CmsBannerComponent, OccConfig } from '@spartacus/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { combineLatest, map, Observable } from 'rxjs';

@Component({
  selector: 'app-general-support-lo-slides',
  templateUrl: './general-support-lo-slides.component.html',
  styleUrl: './general-support-lo-slides.component.scss'
})
export class GeneralSupportLoSlidesComponent {
  constructor(private accessService: ContentService, public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private cd: ChangeDetectorRef,private userInfoService: UserInfoService,private renderer: Renderer2,private baseSiteService:BaseSiteService){}
  uklocontactnode: Observable<any> = this.bannerComponent.data$;
  userLoggedIn: boolean = false;
  userInfo: any;
  currentSite: string | undefined;
  mergedObject1: any = [];
  ngOnInit() {
    this.uklocontactnode.subscribe(res => {
      this.clinicaltabs(res);
    });
      //for logged in, loggedout check
      this.userInfoService.userLoggedIn$.subscribe(res=>{
        this.userLoggedIn = res;
        if(this.userLoggedIn){
          this.userInfoService.getUserData().subscribe(res=>{
            if(res){
            this.userInfo=res;
            }
          });
        }
        this.cd.detectChanges();
      })
      //to get the current basesite 
      this.baseSiteService.getActive().subscribe((siteId) => {
        this.currentSite = siteId;
      });
  }
  clinicaltabs(res: any) {
    const tilesList = res.contactUsSlides.split(" ");
    const observables = tilesList.map((el: any) => this.accessService.helpandaq(el));
    combineLatest(observables).pipe(
      map((results:any) => results.flat())
    ).subscribe((mergedResults: any) => {
      this.mergedObject1 = mergedResults;
      this.cd.detectChanges();
      // console.log(this.mergedObject1);
    });
  }  
}
